<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div
        class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
      >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Torneo</label>
                <select
                  v-model="filters.tournamentId"
                  class="form-select form-control h-45"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsTournament"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Nombre del Partido</label>
                <input
                  type="text"
                  v-model="filters.name"
                  class="form-control h-45"
                  placeholder="Ingrese nombre"
                />
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado Partido</label>
                <select
                  v-model="filters.matchStatusId"
                  class="form-select form-control h-45"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsMatchStatus"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary">Estado Registro</label>
                <select
                  v-model="filters.isActive"
                  class="form-select form-control h-45"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option value="true">{{ STATUS.ACTIVE }}</option>
                  <option value="false">{{ STATUS.INACTIVE }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 text-end mt-4">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <button
                  type="button"
                  @click.prevent="getMatches(currentPage)"
                  class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                >
                  Buscar
                </button>
                <RouterLink to="/match/create">
                  <button
                    type="button"
                    class="btn btn-primary py-1 px-3 fw-medium fs-14 rounded-3 hover-bg"
                  >
                    <span class="py-sm-1 d-block">
                      <span>Agregar Partido</span>
                    </span>
                  </button>
                </RouterLink>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="default-table-area style-two default-table-width">
        <div class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th scope="col" class="text-center"></th>
                <th scope="col">#</th>
                <th scope="col" class="text-center">Torneo</th>
                <th scope="col" class="text-center">Partido</th>
                <th scope="col" class="text-center">Fecha Inicio</th>
                <th scope="col" class="text-center">Fecha Fin</th>
                <th scope="col" class="text-center">Orden</th>
                <th scope="col" class="text-center">Estado Partido</th>
                <th scope="col" class="text-center">Estado Registro</th>
                <th scope="col" class="text-center">Nro. <br />Jugadas</th>
                <th scope="col" class="text-center">
                  Creado<br />
                  por
                </th>
                <th scope="col" class="text-center">Fecha <br />creación</th>
                <th scope="col" class="text-center">Modificado <br />por</th>
                <th scope="col" class="text-center">
                  Fecha <br />
                  modificación
                </th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <draggable
              v-if="items.length"
              v-model="items"
              item-key="id"
              tag="tbody"
              handle=".drag-handle"
              :animation="200"
              :disabled="!enableOrder"
              @end="updateOrderItems"
            >
              <template #item="{ element: item, index }">
                <tr>
                  <td
                    class="text-body text-right drag-handle"
                    :class="{ 'opacity-50': !enableOrder }"
                  >
                    <i
                      class="material-symbols-outlined fs-16 text-primary"
                      :class="
                        enableOrder ? 'cursor-move' : 'cursor-not-allowed'
                      "
                    >
                      drag_indicator
                    </i>
                  </td>
                  <td>
                    {{ index + 1 + (currentPage - 1) * pageSize }}
                  </td>
                  <td class="text-body">{{ item.tournament.name }}</td>
                  <td>{{ item.name }}</td>
                  <td class="text-body">{{ item.startDateTimeString }}</td>
                  <td class="text-body">{{ item.endDateTimeString }}</td>
                  <td class="text-body">{{ item.order }}</td>
                  <td class="text-body text-center">
                    {{ item.matchStatus.name }}
                  </td>
                  <td class="text-body text-center">
                    <span
                      @click="confirmChangeStatus(item.id, item.isActive)"
                      class="badge bg-opacity-10 p-2 fs-12 fw-normal"
                      role="button"
                      :class="computeStatusClass(item.isActive)"
                    >
                      {{ item.isActive ? STATUS.ACTIVE : STATUS.INACTIVE }}
                    </span>
                  </td>
                  <td class="text-body">{{ item.totalPlays }}</td>
                  <td class="text-body">{{ item.createdBy }}</td>
                  <td class="text-body">{{ item.createdAtDateTimeString }}</td>
                  <td class="text-body">{{ item.updatedBy }}</td>
                  <td class="text-body">{{ item.updatedAtDateTimeString }}</td>
                  <td class="text-center">
                    <div class="">
                      <RouterLink :to="`/match/edit/${item.id}`">
                        <i class="material-symbols-outlined fs-16 text-primary">
                          edit
                        </i>
                      </RouterLink>
                    </div>
                  </td>
                </tr>
              </template>
            </draggable>
          </table>
        </div>

        <div class="p-4 pt-lg-4">
          <Pagination
            :currentPage="currentPage"
            :pageSize="pageSize"
            :totalItems="totalItems"
            @update:page="fetchPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
import api from "@/services/api";
import { PAGINATION_ITEMS_PER_PAGE, STATUS, LABELS } from "@/utils/constants";
import draggable from "vuedraggable";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Matches",
  components: {
    Pagination,
    OverlayLoader,
    draggable,
  },
  setup() {
    const isLoading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(PAGINATION_ITEMS_PER_PAGE);
    const totalItems = ref(0);
    const toast = useToast();
    const enableOrder = ref(false);

    const itemsMatchStatus = ref<any[]>([]);
    const itemsTournament = ref<any[]>([]);
    const items = ref<any[]>([]);
    const filters = ref({
      name: "",
      tournamentId: null,
      matchStatusId: null,
      isActive: null,
    });

    const computeStatusClass = (classValue: boolean) => {
      return {
        shipped: classValue,
        deactive: !classValue,
      };
    };

    onMounted(async () => {
      await getMatchStatus();
      await getTournaments();
      await getMatches(currentPage.value);
    });

    const getMatchStatus = async () => {
      try {
        const response = await api.get(`/common/matchStatus`);
        itemsMatchStatus.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    const getTournaments = async () => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;

        const response = await api.get(`/tournament?${params}`);

        itemsTournament.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };

    const getMatches = async (page: number) => {
      try {
        isLoading.value = true;
        var params = `pageNumber=${page}&pageSize=${pageSize.value}`;
        if (filters.value.name) {
          params = params + `&name=${filters.value.name}`;
        }
        if (filters.value.tournamentId) {
          params = params + `&tournamentId=${filters.value.tournamentId}`;
        }
        if (filters.value.matchStatusId) {
          params = params + `&matchStatusId=${filters.value.matchStatusId}`;
        }
        if (filters.value.isActive) {
          params = params + `&isActive=${filters.value.isActive}`;
        }

        const response = await api.get(`/match?${params}`);

        items.value = response.data.list;
        totalItems.value = response.data.rows;
        enableOrder.value =
          filters.value.tournamentId != null &&
          !filters.value.name &&
          filters.value.matchStatusId == null &&
          filters.value.isActive == null;
      } catch (error) {
        console.error(error);
        enableOrder.value = false;
      } finally {
        isLoading.value = false;
      }
    };

    const fetchPage = async (page: number) => {
      currentPage.value = page;
      getMatches(currentPage.value);
    };

    const confirmChangeStatus = async (id: number, status: boolean) => {
      const result = await Swal.fire({
        html: `¿Estás seguro que deseas <b>${
          status ? "desactivar" : "activar"
        }</b> el Partido?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Sí, ${status ? "desactivar" : "activar"} `,
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        isLoading.value = true;

        var obj = {
          id: id,
          status: !status,
        };

        const response: any = await api.put(`/match`, obj);

        if (response != 0) {
          toast.success(
            `El partido fue ${status ? "desactivado" : "activado"} con éxito.`,
            {
              timeout: 2000,
            }
          );
          fetchPage(currentPage.value);
        } else {
          toast.error(
            `El partido no pudo ser ${status ? "desactivado" : "activado"}.`,
            {
              timeout: 2000,
            }
          );
        }
        isLoading.value = false;
      }
    };
    const updateOrderItems = async () => {
      items.value.forEach((item, index) => {
        item.order = index + 1;
      });

      isLoading.value = true;

      try {
        const response: any = await api.put(
          `/match/match-update-order`,
          items.value
        );
        isLoading.value = false;

        if (response.data) {
          toast.success(`Se actualizó el orden de los partidos.`, {
            timeout: 3000,
          });
        }
      } catch (ex) {
        toast.error("El orden de los partidos no pudo ser actualizado.", {
          timeout: 2000,
        });
        console.error(ex);
        isLoading.value = false;
      }
    };
    return {
      items,
      itemsMatchStatus,
      itemsTournament,
      currentPage,
      pageSize,
      totalItems,
      STATUS,
      LABELS,
      OverlayLoader,
      filters,
      isLoading,
      computeStatusClass,
      getMatches,
      fetchPage,
      confirmChangeStatus,
      updateOrderItems,
      enableOrder,
    };
  },
});
</script>
